import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData, convertHtmlTag, convertTagStyle } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './GpPlayLaws.less';

export default class GpPlayLaws extends OfficialPage {
  state = {
    activityType: 0,
    autoRefund: '',
    refundMode: ''
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    var _this = this,
      titleType = ''
    _this.getPlayMessage()
    _this.setData({
      activityType: options.activityType,
      autoRefund: options.autoRefund,
      refundMode: options.refundMode
    })
    switch (options.activityType) {
      case '0':
        titleType = ''
        break
      case '1':
        titleType = '新人团'
        break
      case '2':
        titleType = '阶梯团'
        break
      case '3':
        titleType = '帮帮团'
        break
      case '4':
        titleType = '抽奖团'
        break
    }
    app.setNavigationBarTitle({
      title: titleType + '拼团须知'
    })
  }

  getPlayMessage = () => { }

  componentDidMount() { }

  componentWillUnmount() { }

  onPullDownRefresh = () => { }
  onReachBottom = () => { }
  onShareAppMessage = () => { }

  render() {
    const {
      showGetUserInfo,
      pageQRCodeData,
      activityType,
      autoRefund,
      refundMode
    } = this.state
    return (
      <div className="official-page gp-play-laws">
        <TopNav title="拼团须知" />
        <React.Fragment>
          <div className="collage-playlaws">
            <div className="collage-section collage-play-category">
              {activityType != 4 ? (
                <React.Fragment>
                  <div className="collage-play-sort">
                    <div className="serial-number">1</div>
                    <div className="serial-intro">
                      <div className="title">团长开团</div>
                      <div>
                        <img
                          src="http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/start-immediately(ordinary).png"
                          style={convertLineStyleData('height:308rpx')}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="collage-play-sort">
                    <div className="serial-number">2</div>
                    <div className="serial-intro">
                      <div className="title">选择成团人数</div>
                      <div>
                        <img
                          src="http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/select-num(ordinary).png"
                          style={convertLineStyleData('height:357rpx;')}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="collage-play-sort">
                    <div className="serial-number">3</div>
                    <div className="serial-intro">
                      <div className="title">邀请好友参团</div>
                      <div>
                        <img src="http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/invite-friends(ordinary).png" />
                      </div>
                    </div>
                  </div>
                  <div className="collage-play-sort">
                    <div className="serial-number">4</div>
                    <div className="serial-intro">
                      <div className="title">
                        在时限内达到成团人数，拼团成功
                      </div>
                      <div>
                        <img src="http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/groupSuccess(ordinary).png" />
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                  <React.Fragment>
                    <div className="collage-play-sort">
                      <div className="serial-number">1</div>
                      <div className="serial-intro">
                        <div className="title">团长开团</div>
                        <div>
                          <img
                            src="http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/join-draw(draw).png"
                            style={convertLineStyleData('height:308rpx;')}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="collage-play-sort">
                      <div className="serial-number">2</div>
                      <div className="serial-intro">
                        <div className="title">活动结束前，邀请好友参团</div>
                        <div>
                          <img
                            src="http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/friends-join(draw).png"
                            style={convertLineStyleData('height:360rpx;')}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="collage-play-sort">
                      <div className="serial-number">3</div>
                      <div className="serial-intro">
                        <div className="title">达到抽奖人数，自动开团</div>
                        <div>
                          <img src="http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/automatic-lottery(draw).png" />
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
            </div>
            <div className="collage-section collage-play-intro">
              <div className="title">详细说明</div>
              <div className="collage-intro-step">
                {activityType == 0 ? (
                  <React.Fragment>
                    <div>1.活动期间，用户可以在拼团商品详情下单发起拼团。</div>
                    <div>
                      2.用户支付成功，才算成功开团或参团，创建订单未支付不算有效参与拼团玩法。
                    </div>
                    <div>
                      3.先付款的成员先加入团，每位用户在同一团内可购买多件，但只占1个拼团人数，且不可重复参团。
                    </div>
                    <div>
                      {autoRefund == 1 ? (
                        <React.Fragment>
                          4.在规定时间内达到成团人数，则拼团成功，商家分别发货；未能在规定时间内达到成团人数，则拼团失败，系统自动退款。
                        </React.Fragment>
                      ) : (
                          <React.Fragment>
                            4.在规定时间内达到最低成团人数，则拼团成功，商家分别发货；未能在规定时间内达到成团人数，则拼团失败，联系商家申请退款。
                        </React.Fragment>
                        )}
                    </div>
                  </React.Fragment>
                ) : (
                    activityType == 1 && (
                      <React.Fragment>
                        <div>
                          1.活动期间，用户可以在拼团商品详情下单发起拼团。
                      </div>
                        <div>
                          2.用户支付成功，才算成功开团或参团，创建订单未支付不算有效参与拼团玩法。
                      </div>
                        <div>
                          3.新人团需小程序新用户（即24小时内首次登陆，且未参与过拼团的用户）方可参团，先付款的成员先加入团，每位用户在同一团可购买多件，但只占1个拼团人数，且不可重复参团。
                      </div>
                        <div>
                          {autoRefund == 1 ? (
                            <React.Fragment>
                              4.在规定时间内达到成团人数，则拼团成功，商家分别发货；未能在规定时间内达到成团人数，则拼团失败，系统自动退款。
                          </React.Fragment>
                          ) : (
                              <React.Fragment>
                                4.在规定时间内达到最低成团人数，则拼团成功，商家分别发货；未能在规定时间内达到成团人数，则拼团失败，联系商家申请退款。
                          </React.Fragment>
                            )}
                        </div>
                      </React.Fragment>
                    )
                  )}
                {activityType == 2 ? (
                  <React.Fragment>
                    <div>1.活动期间，用户可以在拼团商品详情下单发起拼团。</div>
                    <div>
                      2.用户支付成功，才算成功开团或参团，创建订单未支付不算有效参与拼团玩法。
                    </div>
                    <div>
                      {refundMode == 1 ? (
                        <React.Fragment>
                          3.阶梯团参团人数越多，价格越低，支付差价将在确认收货后返还成储值金。每位用户在同一团内可购买多件，但只占1个拼团人数，且不可重复参团。
                        </React.Fragment>
                      ) : (
                          <React.Fragment>
                            3.阶梯团参团人数越多，价格越低，支付差价将在确认收货后返还到支付账号。每位用户在同一团内可购买多件，但只占1个拼团人数，且不可重复参团
                        </React.Fragment>
                        )}
                    </div>
                    <div>
                      {autoRefund == 1 ? (
                        <React.Fragment>
                          4.在规定时间内达到最低成团人数，则拼团成功，商家分别发货；未能在规定时间内达到成团人数，则拼团失败，系统自动退款。
                        </React.Fragment>
                      ) : (
                          <React.Fragment>
                            4.在规定时间内达到最低成团人数，则拼团成功，商家分别发货；未能在规定时间内达到成团人数，则拼团失败，联系商家申请退款。
                        </React.Fragment>
                        )}
                    </div>
                  </React.Fragment>
                ) : activityType == 3 ? (
                  <React.Fragment>
                    <div>
                      1.帮帮团的理念是邀请好友帮助支付获得商品，拼团成功后，商家只给团长发货。
                    </div>
                    <div>2.活动期间，用户可以在拼团商品详情下单发起拼团。</div>
                    <div>
                      3.用户支付成功，才算成功帮助成团，创建订单未支付不算有效参与帮帮团，先付款的成员先加入团，用户不可重复参同一团。
                    </div>
                    <div>
                      4.在规定时间内达到帮帮团人数，则拼团成功，团长获得商品；未能在规定时间内达到成团人数，则拼团失败，系统自动退款。
                    </div>
                  </React.Fragment>
                ) : (
                      activityType == 4 && (
                        <React.Fragment>
                          <div>
                            1.用户支付一定金额获得抽奖机会，当参加抽奖用户支付金额达到抽奖门槛，系统自动抽取1名中奖用户，其他未中奖用户将获得等额储值金。活动结束仍未达到抽奖门槛，系统自动退款。
                      </div>
                          <div>
                            2.活动期间，用户可以在拼团商品详情支付参与抽奖。购买数量越多，中奖概率越大。
                      </div>
                          <div>
                            3.用户支付成功，才算成功参与抽奖，创建订单未支付不算有效参团玩法。
                      </div>
                        </React.Fragment>
                      )
                    )}
              </div>
            </div>
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/gp-play-laws/GpPlayLaws.jsx